"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunkHJFO65XKcjs = require('./chunk-HJFO65XK.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v2_1/pool/CPIPoolV2_1.ts
var CPIPoolV2_1 = (_class = class extends _chunkHJFO65XKcjs.BasePoolV2_1 {
  static __initStatic() {this.dexType = _chunkNE5AG7IWcjs.DEX_TYPE.CPI}
  async getPoolData(provider) {
    const data = await this.implGetPoolData(provider);
    return {
      ...data.commonPoolData
    };
  }
}, _class.__initStatic(), _class);



exports.CPIPoolV2_1 = CPIPoolV2_1;
//# sourceMappingURL=chunk-64FNDIZX.cjs.map